<template>
	<view>
		<view class="header" ref="header" :style="isFix?'position: fixed;':'position: relative;'">
			<view class="header-box" v-if="isSearch">
				<view class="header-content" :style="tabs.length?'':'padding-bottom: 10rpx;'">
					<u-search class="header-input uni-mt-5" shape="square" :showAction="false" :placeholder="placeholder" v-model="searchValue" @input="search" @clear="clear"></u-search>
					<!-- <image class="header-icon" src="../../static/saos.png" mode="" @tap="scanCode"></image> -->
					<!-- 二维码扫描 -->
					<view v-if="isScanPop" class="header-icon">
						<scanPop :width="50" :height="50" @scanCode='scanCode'></scanPop>
					</view>
					<view style="margin-left:10px">
						<slot name="filter"></slot>
					</view>
				</view>
				<view style="margin-bottom:10px">
					<slot name="header"></slot>
				</view>
				<view style="margin-left:15px">
					<slot name="select"></slot>
				</view>
				<view class="tab-box" v-if="tabs.length">
					<template>
						<view v-for="item in tabs" :key="item.id" :class="activeIndex == item.id ? 'tab-txt active' : 'tab-txt'" @tap="changeTab(item.id)">
							{{ item.name}}
						</view>
					</template>
				</view>
			</view>
		</view>
		<!-- 适配小程序/app，占位导航栏 -->
		<view :style="tabs.length>0?'height:100px':'height:70px'"></view>
	</view>

</template>

<script>
	export default {
		props: {
			//是否固定导航栏
			isFix: {
				type: Boolean,
				default: true
			},
			//是否显示适配H5适配
			isAppBar: {
				type: Boolean,
				default: true
			},
			//是否显示搜索框
			isSearch: {
				type: Boolean,
				default: true
			},
			//搜索框提示文字
			placeholder: {
				type: String,
				default: ''
			},
			// 搜索框内容
			// searchValue: {
			// 	type: String,
			// 	default: ''
			// },
			// tab列表数组
			tabs: {
				type: Array,
				default: () => []
			},
			// 当前选中tab索引
			activeIndex: {
				type: String | Number,
				default: ''
			},
			// 导航栏标题
			title: {
				type: String,
				default: ''
			},
			// 导航栏是否显示返回按钮
			isShowBackbtn: {
				type: Boolean,
				default: false
			},
			// 是否展示扫码
			isScanPop: {
				type: Boolean,
				default: true
			}
			//是否调出扫描
			// isShowScan:{
			// 	type: Boolean,
			// 	default: false
			// },
		},
		mounted() {
			// let view = uni.createSelectorQuery().select(".header");
			// console.log(view,'view')
			// view.boundingClientRect((data)=> {
			// 	//获取固定尾部的高度=data.height
			// 	this.headHeight = data.height
			// 	console.log(this.headHeight,'this.headHeight ')
			// }).exec();
		},
		data() {
			return {
				isShowScan: false,
				headHeight: 70,
				searchValue: "",
			}
		},
		methods: {
			//搜索
			search(e) {
				const vm = this;
				// 输入框防抖
				/** 每次进来的时候都将之前的清除掉，如果还没到一秒的时候就将之前的清除掉，这样就不会触发之前setTimeout绑定的事件， 
				如果超过一秒，之前的事件就会被触发下次进来的时候同样清除之前的timer**/
				clearTimeout(vm.timer)
				vm.timer = setTimeout(() => {
					// 执行搜索
					this.$emit('search', e);
				}, 500)
			},
			//调起扫码
			scanCode(res) {
				this.$emit('scanCode', res);
			},
			//切换tab
			changeTab(e) {
				this.$emit('changeTab', e);
			},
			// 清空搜索框
			clear() {
				this.searchValue = ''
			}
		}
	};
</script>

<style lang="scss" scoped scoped>
	.header {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;
		// background-color: rgb(24, 144, 255);
		background-color: #fff;
		width: 100%;
		box-sizing: border-box;
		font-size: 12px;

		.header-box {
			.header-content {
				padding: 40rpx 30rpx 0;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				border-radius: 10rpx;

				.header-input {
					margin-right: 16rpx;
					background-color: #FFF;
					border-radius: 6rpx;
				}

				.header-icon {
					// width: 50rpx;
					// height: 50rpx;
					margin-left: 16rpx;
				}
			}

			.tab-box {
				box-sizing: border-box;
				padding: 0rpx 20rpx 18rpx;
				display: flex;
				justify-content: space-around;

				.tab-txt {
					// width: 15%;
					height: 100%;
					text-align: center;
					line-height: 50rpx;
					color: #000;
				}

				.active {
					border-bottom: 2px solid #1890ff;
					color: #1890ff;
					font-weight: bold;
				}
			}

			.header-radius {
				width: 100%;
				margin-bottom: -1px;

				.header-radius-con {
					width: 100%;
					height: 20rpx;
					border-top-left-radius: 20rpx;
					border-top-right-radius: 20rpx;
					background-color: #F5F5F5;
				}
			}
		}
	}

	.packing-record {
		.packing-order {
			border: 1px solid #eee;
			border-radius: 10rpx;
			padding: 20rpx;
			line-height: 1.8;
			margin: 10rpx 20rpx 20rpx;

			.packing-num {
				font-size: 32rpx;
				font-weight: bold;
			}

			.packing-content {
				display: flex;
				justify-content: space-between;

				.total-num {
					display: flex;
				}

				.create-info {
					color: #aaa;
					display: flex;
				}
			}
		}
	}
</style>